module.exports = __webpack_public_path__ + "static/media/404.a925745b.svg";